import script from "./KSDataComparison.vue?vue&type=script&setup=true&lang=js"
export * from "./KSDataComparison.vue?vue&type=script&setup=true&lang=js"

import "./KSDataComparison.vue?vue&type=style&index=0&id=b1f76e70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1f76e70"]])

export default __exports__